import { Paywall as PaywallComponent } from '@trmediaab/site-offers';
import theme from '@trmediaab/theme-jokersystemet';
import { Text, ThemeProvider } from '@trmediaab/zebra';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { fetchUser } from 'shared/redux/actions';
import { fetchOffers } from 'shared/redux/actions/offerActions';
import { offers, user } from 'shared/redux/selectors';
import { parseQueryString } from 'shared/utils';
import { usePaywallContext } from 'shared/utils/protectedResources';
import { getUrl } from 'shared/utils/urls';

import Loader from '../loader/Loader';
import styles from './index.module.scss';

const Paywall = ({
  disallowUserChange = false,
  returnUrl,
  returnUrlText,
  fullHeight = false,
}) => {
  const paywallContext = usePaywallContext();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(user.isLoggedIn);
  const fetchedOffers = useSelector(offers.getOffers);
  const location = useLocation();
  const { orderId } = parseQueryString(location.search);

  useEffect(() => {
    dispatch(fetchOffers());
  }, [dispatch]);

  useLayoutEffect(() => {
    const scrollTarget = document.querySelector('[data-id="paywall"]');
    window.scroll({
      top: scrollTarget.getBoundingClientRect().top + window.scrollY - 100,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div
      className={classnames({
        [styles.root]: true,
        [styles.fullHeight]: fullHeight,
      })}
      data-id="paywall"
    >
      <Loader
        visible={fetchedOffers.isLoading}
        labelProp="main-loader-offers-heading"
        className={styles.loader}
        cover={fullHeight}
      />
      {fetchedOffers.data != null && (
        <ThemeProvider theme={theme} disableGlobalStyles>
          <Text.root>
            <PaywallComponent
              reason={isLoggedIn == null ? 'not_logged_in' : 'unauthorized'}
              contentType="service"
              authUrl={getUrl.login()}
              products={fetchedOffers.data.products}
              campaigns={fetchedOffers.data.campaigns}
              site={process.env.REACT_APP_TRAIS_SITE}
              orderId={orderId}
              returnUrl={returnUrl}
              returnUrlText={returnUrlText}
              disallowUserChange={disallowUserChange}
              onCancel={paywallContext.cancelPaywall}
              onAuthentication={() => dispatch(fetchUser())}
            />
          </Text.root>
        </ThemeProvider>
      )}
    </div>
  );
};

Paywall.propTypes = {
  disallowUserChange: PropTypes.bool,
  returnUrl: PropTypes.string,
  returnUrlText: PropTypes.string,
  fullHeight: PropTypes.bool,
};

export default Paywall;
